import * as React from 'react';

import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';

import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';

import EditIcon from '@material-ui/icons/Edit';
import ViewOnlyIcon from '@material-ui/icons/VisibilityOff';
import SubmitIcon from '@material-ui/icons/Check';
import DeleteIcon from '@material-ui/icons/Delete';

import * as actions from '../../modules/popup/action';

interface IProps {
  formDisabled: boolean;
  isSubmitting: boolean;
  showEdit: boolean;
  showDelete: boolean;
  onEditStart: () => void;
  onEditCancel: () => void;
  openDeleteDialog: () => void;
}

const EditIcons = (props: IProps) => {
  const {
    formDisabled,
    isSubmitting,
    onEditStart,
    onEditCancel,
    openDeleteDialog,
    showEdit,
    showDelete
  } = props;

  return (
    <span>
      {!formDisabled && (
        <Tooltip title="Confirm">
          <span>
            <IconButton type="submit" disabled={formDisabled || isSubmitting}>
              <SubmitIcon />
            </IconButton>
          </span>
        </Tooltip>
      )}
      {showEdit &&
        (!formDisabled ? (
          <Tooltip title="View Only">
            <span>
              <IconButton
                onClick={onEditCancel}
                disabled={formDisabled || isSubmitting}
              >
                <ViewOnlyIcon />
              </IconButton>
            </span>
          </Tooltip>
        ) : (
          <Tooltip title="Edit">
            <span>
              <IconButton onClick={onEditStart} disabled={!formDisabled}>
                <EditIcon />
              </IconButton>
            </span>
          </Tooltip>
        ))}
      {showDelete && (
        <Tooltip title="Delete">
          <span>
            <IconButton onClick={openDeleteDialog} disabled={isSubmitting}>
              <DeleteIcon />
            </IconButton>
          </span>
        </Tooltip>
      )}
    </span>
  );
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators(
    { openDeleteDialog: actions.openDeleteDialog },
    dispatch
  );
};

export default connect(
  null,
  mapDispatchToProps
)(EditIcons);



// WEBPACK FOOTER //
// ./src/common/edit-icons/edit-icons.tsx